import { requireSupabase } from "@/lib/supabaseClient";
import { guard } from "@/lib/errors";

export const savedSearchService = {
  list: (userId) =>
    guard("savedSearchService.list", async () => {
      const supabase = requireSupabase();
      const { data, error } = await supabase
        .from("saved_searches")
        .select("*")
        .eq("user_id", userId)
        .order("created_at", { ascending: false });
      if (error) throw error;
      return data || [];
    }),

  create: (userId, { name, query, filters = {}, mapState = null, notify = null } = {}) =>
    guard("savedSearchService.create", async () => {
      const supabase = requireSupabase();
      // Map location/zoom/polygon + notification preference are nested inside the
      // filters JSONB so no schema change is required (100% additive).
      const enriched = {
        ...filters,
        ...(mapState ? { _map: mapState } : {}),
        ...(notify ? { _notify: notify } : {}),
      };
      const { data, error } = await supabase
        .from("saved_searches")
        .insert({ user_id: userId, name, query, filters: enriched })
        .select()
        .maybeSingle();
      if (error) throw error;
      return data;
    }),

  remove: (id) =>
    guard("savedSearchService.remove", async () => {
      const supabase = requireSupabase();
      const { error } = await supabase.from("saved_searches").delete().eq("id", id);
      if (error) throw error;
      return true;
    }),
};
